/* ═══
   TAIBI · le collezioni si aprono al passaggio del mouse
   File nostro. Su desktop la tendina si apre passandoci sopra, non solo con
   il clic: con il puntatore esplorare un menu è un movimento continuo, e
   obbligare a un clic per ogni categoria lo spezza.

   ⚠️ NON sostituisce il clic, si aggiunge. Il clic continua a funzionare —
   è `<details>`, lo fa il browser — e con la tastiera si apre con Invio come
   prima. Chi arriva col dito non entra mai qui: la condizione è
   `hover: hover` e `pointer: fine`, quindi un tablet resta al clic.

   ⚠️ Due ritardi, e sono due cose diverse:
   · **90ms per aprire** — è il filtro dell'intenzione. Senza, attraversando
     la barra per arrivare al carrello si aprirebbero e chiuderebbero sei
     tendine di fila;
   · **220ms per chiudere** — è la tolleranza del percorso. Il pannello sta
     sotto la voce, e nel tragitto in diagonale il puntatore esce dalla voce
     prima di entrare nel pannello: senza questo ritardo la tendina si
     chiuderebbe sotto il dito.

   ⚠️ I listener stanno sul `document`, non sugli elementi del menu: nel tema
   l'header viene ridisegnato dall'editor e dal carrello ajax, e dei listener
   attaccati alle voci morirebbero con loro.
   ═══ */

(function () {
  'use strict';

  var APERTURA = 90;
  var CHIUSURA = 220;

  var puntatoreFine = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var timerApri = null;
  var timerChiudi = null;
  var inAttesa = null;

  function menuDa(elemento) {
    if (!elemento || !elemento.closest) return null;
    return elemento.closest('.header__inline-menu header-menu');
  }

  function apri(menu) {
    var dettagli = menu.querySelector('details');
    if (!dettagli || dettagli.hasAttribute('open')) return;

    chiudiTutti(menu);
    dettagli.setAttribute('open', '');

    /* ⚠️ `aria-expanded` lo scrive solo la `close()` di Dawn, mai l'apertura.
       Aprendo da qui lo dichiariamo noi, o chi ascolta sentirebbe «chiuso»
       davanti a una tendina aperta. */
    var sommario = dettagli.querySelector('summary');
    if (sommario) sommario.setAttribute('aria-expanded', 'true');
  }

  function chiudi(menu) {
    /* `close()` arriva da `DetailsDisclosure` di Dawn: toglie l'attributo e
       rimette `aria-expanded`. Usiamo la sua, così le animazioni che Dawn
       aggancia al `toggle` restano coerenti. */
    if (menu && typeof menu.close === 'function') menu.close();
  }

  function chiudiTutti(tranne) {
    var aperti = document.querySelectorAll('.header__inline-menu header-menu');
    for (var i = 0; i < aperti.length; i++) {
      if (aperti[i] !== tranne) chiudi(aperti[i]);
    }
  }

  function annullaTimer() {
    clearTimeout(timerApri);
    clearTimeout(timerChiudi);
  }

  document.addEventListener('mouseover', function (evento) {
    if (!puntatoreFine.matches) return;

    var menu = menuDa(evento.target);
    if (!menu) return;

    clearTimeout(timerChiudi);
    if (inAttesa === menu) return;

    clearTimeout(timerApri);
    inAttesa = menu;
    timerApri = setTimeout(function () {
      apri(menu);
    }, APERTURA);
  });

  document.addEventListener('mouseout', function (evento) {
    if (!puntatoreFine.matches) return;

    var menu = menuDa(evento.target);
    if (!menu) return;

    /* Uscire verso un figlio non è uscire: `relatedTarget` dice dove sta
       andando il puntatore, e se è ancora dentro lo stesso menu non succede
       niente. Senza questo controllo la tendina si chiuderebbe passando dal
       testo della voce al suo chevron. */
    if (evento.relatedTarget && menuDa(evento.relatedTarget) === menu) return;

    clearTimeout(timerApri);
    inAttesa = null;
    timerChiudi = setTimeout(function () {
      chiudi(menu);
    }, CHIUSURA);
  });

  /* Uscendo dall'header si chiude subito: fuori di lì non c'è nessun percorso
     da tollerare. */
  document.addEventListener('mouseout', function (evento) {
    if (!puntatoreFine.matches) return;
    if (!evento.target.closest || !evento.target.closest('.header-wrapper')) return;
    if (evento.relatedTarget && evento.relatedTarget.closest && evento.relatedTarget.closest('.header-wrapper')) return;
    annullaTimer();
    inAttesa = null;
    chiudiTutti(null);
  });

  /* ⚠️ Il clic deve restare padrone. Se il puntatore ha già aperto la tendina
     e poi si clicca, `<details>` la chiude: è il comportamento giusto, e per
     ottenerlo basta togliersi di mezzo — si annullano i timer, altrimenti
     quello dell'apertura la riaprirebbe subito dopo. */
  document.addEventListener('click', function (evento) {
    if (menuDa(evento.target)) {
      annullaTimer();
      inAttesa = null;
    }
  });
})();

/* ═══
   TAIBI · le categorie su due righe
   Aggiunge `header--menu-a-capo` all'header quando le voci del menu non
   stanno più su una riga sola. Serve al CSS per stringere le righe e
   centrarle: **in CSS non esiste un selettore per «sono andato a capo»**, e
   questa è l'unica cosa che questo blocco fa.

   ⚠️ Le righe si contano dalla POSIZIONE delle voci, non dall'altezza del
   contenitore: `top` arrotondato, quanti valori distinti. Contare
   sull'altezza avrebbe voluto dire conoscere l'altezza di una riga, che
   cambia proprio con la classe che stiamo per mettere — cioè misurare una
   cosa che stiamo modificando.

   ⚠️ **Non si tocca mai la larghezza**, né qui né nel CSS che ne consegue.
   La larghezza è ciò che decide il capo: stringerla farebbe rientrare le
   voci, la classe sparirebbe, tornerebbero larghe e andrebbero di nuovo a
   capo. Un'oscillazione senza fine, e il rimedio è non misurare ciò che si
   modifica.

   ⚠️ Niente `customElements` qui, ed è una deroga dichiarata: il nostro
   custom element dovrebbe avvolgere `.header__inline-menu`, che è un
   elemento di griglia con `grid-area` — un involucro in mezzo romperebbe
   l'impaginazione dell'header. Il caso dell'editor, che è il motivo per cui
   la regola esiste, è coperto lo stesso: si riascolta `shopify:section:load`.
   ═══ */
(function () {
  var CLASSE = 'header--menu-a-capo';
  var osservatore = null;

  function righe(lista) {
    var quote = {};
    var n = 0;
    Array.prototype.forEach.call(lista.children, function (voce) {
      var y = Math.round(voce.getBoundingClientRect().top);
      if (!quote[y]) {
        quote[y] = true;
        n += 1;
      }
    });
    return n;
  }

  function applica() {
    var header = document.querySelector('.header');
    if (!header) return;
    var lista = header.querySelector('.header__inline-menu > .list-menu');
    /* Nessun menu in riga — vista mobile, o menu a tendina laterale: la
       classe va tolta, non lasciata addosso da un ridimensionamento prima. */
    if (!lista || !lista.children.length || !lista.offsetParent) {
      header.classList.remove(CLASSE);
      return;
    }
    header.classList.toggle(CLASSE, righe(lista) > 1);
  }

  function osserva() {
    var lista = document.querySelector('.header__inline-menu > .list-menu');
    if (!lista) return;
    if (osservatore) osservatore.disconnect();
    if (!('ResizeObserver' in window)) return;
    /* Si osserva la LISTA e non la finestra: cambia anche quando cambiano le
       voci del menu o il peso del testo, non solo quando si ridimensiona. */
    osservatore = new ResizeObserver(applica);
    osservatore.observe(lista);
  }

  function avvia() {
    applica();
    osserva();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  /* Ripiego per chi non ha ResizeObserver: iOS Safari 14 ce l'ha, ma un
     `resize` costa niente e copre anche la rotazione del dispositivo. */
  window.addEventListener('resize', applica);

  /* Nell'editor la sezione viene ridisegnata a ogni modifica: l'elemento
     osservato non esiste più e la classe se ne va con lui. */
  document.addEventListener('shopify:section:load', avvia);
})();
